import type { SVGProps } from "react";
export interface Numer1CircleIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function Numer1CircleIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: Numer1CircleIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 12a8.875 8.875 0 1 0-17.75 0 8.875 8.875 0 0 0 17.75 0m2.25 0c0 6.144-4.98 11.124-11.124 11.125S.875 18.145.875 12 5.856.875 12.001.875c6.143 0 11.124 4.981 11.124 11.126Z"
      />
      <path
        fill={color}
        d="M12.32 6.876c.593.038 1.055.53 1.055 1.124v6.874H14.5l.116.006a1.126 1.126 0 0 1 0 2.239l-.116.006H10a1.125 1.125 0 0 1 0-2.25h1.125v-3.882a3 3 0 0 1-.598.118l-.293.013H10a1.125 1.125 0 0 1 0-2.25h.234l.162-.014a.875.875 0 0 0 .707-.752l.03-.247a1.126 1.126 0 0 1 1.187-.985"
      />
    </svg>
  );
}
